import { AlertSeverity } from 'app/alerts/models/Alert';
import { GatewayId } from 'app/site-gateway/models/gateway';
import { getClientName } from 'app/site-owner/utils/owner.util';
import { toShortDate } from 'app/utils/date';

import { SiteListRow, SiteListSite } from '../models/site-list';

import { hasBeeconBoxesOnly, hasNoBox } from './sites.utils';

export function buildSiteListRows(
    sites: readonly SiteListSite[],
    isToolbox: (gatewayIds?: readonly GatewayId[]) => boolean,
    alertsSeverityBySites: Readonly<Record<string, AlertSeverity>> = {},
): SiteListRow[] {
    return sites.map((site) => {
        const toolbox = isToolbox(site.setupGateways);

        return {
            site,
            clientName: getClientName(site, toolbox) || '—',
            activationDate: site.activateDate && !toolbox ? toShortDate(site.activateDate) : '',
            alertsSeverity: alertsSeverityBySites[site.id] ?? null,
            isToolbox: toolbox,
            unavailableReasonKey: getUnavailableReasonKey(site, toolbox),
        };
    });
}

function getUnavailableReasonKey(site: SiteListSite, isToolbox: boolean): string | undefined {
    if (isToolbox) return 'TOOL_SITE_DESCRIPTION';
    if (hasNoBox(site)) return 'INACTIVE_SITE_DESCRIPTION';
    if (hasBeeconBoxesOnly(site)) return 'BEECON_ONLY_SITE_DESCRIPTION';

    return undefined;
}
